module.exports = __webpack_public_path__ + "img/IMG_9701_L_Foamcore.907a4745.jpg";